import styled from "styled-components";

export const StyledApplyToWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  grid-gap: 15px;
`;

export const StyledApplyToItem = styled.div`
  display: grid;
  grid-gap: 15px;
  button {
    padding: 0;
    font-size: 14px;
  }
`;
